import {IPlaylistMedia} from '@interfaces/playlist';
import {ISchedule} from '@interfaces/schedule';

export class GetGroups {
  static readonly type = '[Modals] Get groups';

  constructor(public params: { limit: number, skip?: number, search?: string }) {
  }
}

export class CleanGroups {
  static readonly type = '[Modals] Clean groups';
}

export class GetDevicesWithoutGroup {
  static readonly type = '[Modals] Get devices without group';

  constructor(public params: { limit: number, skip?: number, search?: string, order?: string }) {
  }
}

export class CleanDevicesWithoutGroup {
  static readonly type = '[Modals] Clean devices without group';
}

export class GetDevicesFromGroupToEdit {
  static readonly type = '[Modals] Get devices from group to edit';

  constructor(public params: { groupId: number, limit: number, skip: number, search: string, order?: string }) {
  }
}

export class CleanDevicesFromGroupToEdit {
  static readonly type = '[Modals] Clean devices from group to edit';
}

export class SetEventToEdit {
  static readonly type = '[Modals] Set event to edit';

  constructor(
    public payload: ISchedule | null,
    public deviceGroupName: string,
    public scheduleId: number,
    public description: string
  ) {
  }
}

export class CleanEventToEdit {
  static readonly type = '[Modals] Clean event to edit';

  constructor() {
  }
}

export class SetDeviceToEventEdit {
  static readonly type = '[Modals] Set device to edited event';

  constructor(public device: number, public name: string) {
  }
}

export class SetGroupToEventEdit {
  static readonly type = '[Modals] Set group to edited event';

  constructor(public group: number, public name: string) {
  }
}

export class SetPlaylistToEventEdit {
  static readonly type = '[Modals] Set playlist to edited event';

  constructor(public playlist: number, public description: string, public name: string) {
  }
}

export class SetMediaToEventEdit {
  static readonly type = '[Modals] Set media to edited event';

  constructor(public media: IPlaylistMedia[], public playlistName: string) {
  }
}

export class SetTimeToEditEvent {
  static readonly type = '[Modals] Set time to update schedule';

  constructor(
    public payload: {
      startLocal: string,
      endLocal: string,
      endLocalTimeStamp: string,
      scheduleType: 'period' | 'allday' | 'repetetive' | 'constant' | null,
      repetition: string | null
    }
  ) {
  }
}

export class UpdateEvent {
  static readonly type = '[Modals] Update event';
}

